import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom"
import styles from "../../styles/Account.module.css";
import TopBoxSign from "../../components/TopBoxSign";
import { Button as ManButton } from "@mantine/core";
import Button from "react-bootstrap/Button";
import btnStyles from "../../styles/Button.module.css";
import toast from "react-hot-toast";
import { axiosInstance } from "../../api/axiosDefaults";
import InfoCon from "./InfoCon";

export default function () {
  const history = useHistory();
  const [show, setShow] = useState(false)

  const [data, setData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.name || !data.contactNumber || !data.email || !data.message) {
      toast.error("All the fields are required!");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axiosInstance.post(
        `/contacts/`,
        {
          name: data.name,
          email: data.email,
          contact: data.contactNumber,
          message: data.message,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      setData({
        ...data,
        contactNumber: "",
        email: "",
        message: "",
        name: "",
      });
    } catch (err) {
      toast.error("Failed to contact. Try again!");
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const buttons = (
    <div
      className="mt-3"
      style={{ width: "100%", display: "flex", justifyContent: "center" }}
    >
      <ManButton
        disabled={isLoading}
        type="submit"
        sx={(theme) => ({
          backgroundColor: theme.colors.lightBlue,
        })}
      >
        Send
      </ManButton>
    </div>
  );
  return (
    <div>
      <div className="px-3">
      {/* <div className={`${styles.Top}`}>
            <Row className="py-3 text-center">
            <Col className=" d-flex align-items-center justify-content-center">
            <h3 
            style={{
                    textTransform: "uppercase",
                    // fontFamily: "Playfair Display",
                  }}
            className={` ${styles.TopName2} pt-3`}>
                Contact Us
            </h3>
            </Col>
          </Row>
      </div> */}
        <TopBoxSign title="Contact Us" />
      </div>
      <Row className="my-2 px-3">
        <Col xs={6} className="">
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        <Col xs={6} >
        <Button
          className={`float-right px-3 ${btnStyles.Button} ${btnStyles.Order}`}
          onClick={() => setShow(show => !show)}
        >INFO
        </Button>
        </Col>
      </Row>
      {!show ? "" : <InfoCon />}
      <h5
            style={{ textTransform: "uppercase" }}
            className={`mt-1 mb-1 pl-3 py-1 ${styles.SubTitle} text-center`}
          >
            CONTACT US
      </h5>
      <Row>
        <Col className={`mt-3`} md={{ span: 10, offset: 1 }}>
              <Form onSubmit={handleSubmit} className={`${styles.WhiteBack } px-3`}>
                <Row className={styles.ContactRow}>
                <Col md={6}>
                <Row>
                  <Col xs={12} className="text-center">
                    <Form.Group
                      controlId="name"
                      className={`${styles.Width80}`}
                    >
                      <Form.Label className={`${styles.BoldScene} `}>
                        Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className={styles.Input}
                        name="name"
                        value={data.name}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} className="text-center mt-2">
                    <Form.Group controlId="email"
                      className={`${styles.Width80}`}>
                      <Form.Label className={`${styles.BoldScene} `}>
                        Email
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className={styles.Input}
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} className="text-center mt-2">
                    <Form.Group
                      controlId="contactNumber"
                      className={`${styles.Width80}`}
                    >
                      <Form.Label className={`${styles.BoldScene} `}>
                        Contact Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className={styles.Input}
                        name="contactNumber"
                        value={data.contactNumber}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                </Col>
                <Col md={6}>
                <Col xs={12} className="text-center mt-2">
                    <Form.Group
                      controlId="message"
                      className={`${styles.Width80}`}
                    >
                      <Form.Label className={`${styles.BoldScene} `}>
                        Message
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        className={styles.InputScene}
                        rows={6}
                        name="message"
                        value={data.message}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </Form.Group>
                  </Col>
                </Col>
                </Row>
                  <Row className="text-center mt-3">
                          <Col className="mt-3">
                            <Button
                              className={`${btnStyles.Button} ${btnStyles.Blue} mr-3 px-3 px-md-5`}
                              onClick={() => history.goBack()}
                            >
                              Cancel
                            </Button>
                            <Button
                              className={`${btnStyles.Button} ${btnStyles.Blue} ml-3 px-3 px-md-5`}
                              type="submit" disabled={isLoading}
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                    {/* <div className={`mt-1`}>{buttons} </div> */}

              </Form>
            {/* </div>
          </div> */}
        </Col>
      </Row>
    </div>
  );
}
